import React, { useEffect, useRef, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import InfoWebCoreApi from "../../common/infoweb/infoWebCoreApi";
import { PageData, PageReference } from "../../types/InfoWebTypes";

const SupportPageType: Page = {
  ActiveTab: "support",
  DisplayName: "Ohjeet ja vinkit",

  LinkUrl: "/support",
  Path: "/support",
  RouteName: "support",
};

const SupportPage = () => {
  const [pageData, setPageData] = useState<PageData>();
  const [pageListPages, setPageListPages] = useState<PageReference[]>();
  const [allPages, setAllPages] = useState<PageReference[]>();
  const searchInput = useRef<HTMLInputElement>();
  const nav = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      var pd = await InfoWebCoreApi.GetPageByPathAsync("fi/omistajalle");
      var ap = await InfoWebCoreApi.GetPagesAsync("fi");

      if (pd != null) {
        setPageData(pd);

        var pageListWidget = pd.content.FlowPart?.Widgets?.find(
          (f) => f.ContentType == "PageListWidget",
        );

        if (pageListWidget != null && pageListWidget.Pages?.length > 0) {
          setPageListPages(pageListWidget.Pages);
        }
      }

      if (ap != null) {
        setAllPages(ap);
      }
    };

    fetchData().catch(console.error);
  }, []);

  const onKeyUp = (e: any) => {
    if (e.key == "Enter") {
      goToSearch();
    }
  };

  const goToSearch = () => {
    nav("/support/search?q=" + searchInput.current.value);
  };

  return (
    <div className={SupportPageType.RouteName}>
      <Layout CurrentPage={SupportPageType}>
        <PageHeader
          Title={SupportPageType.DisplayName}
          SubTitle={SupportPageType.DisplayParentName}
          Back={false}
          Icon="question-lg"
        ></PageHeader>

        <div className="bg-primary d-flex align-items-center justify-content-center m-n24 m-lg-n40 mb-n40 p-24 p-lg-64 position-relative">
          <svg
            className="position-absolute opacity-25 end-0 top-0"
            width="470"
            height="470"
            viewBox="0 0 470 470"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M409.261 244.038H390.24V225.016H409.261V244.038ZM365.714 116.802L352.268 130.248L338.822 116.802L352.268 103.356L365.714 116.802ZM351.766 234.895C351.766 299.651 299.273 352.145 234.517 352.145C169.761 352.145 117.267 299.651 117.267 234.895C117.267 170.138 169.761 117.645 234.517 117.645C299.273 117.645 351.766 170.138 351.766 234.895ZM244.037 77.5572H225.015V58.5354H244.037V77.5572ZM130.247 116.802L116.801 130.248L103.355 116.802L116.801 103.356L130.247 116.802ZM103.803 351.822L117.249 338.376L130.695 351.822L117.249 365.268L103.803 351.822ZM225.015 390.887H244.037V409.909H225.015V390.887ZM337.908 351.374L351.354 337.928L364.8 351.374L351.354 364.82L337.908 351.374ZM77.5567 244.038H58.5351V225.016H77.5567V244.038ZM421.972 176.969H373.459L408.24 142.224L400.208 68.5393L326.362 61.2963L292.066 95.6108V46.4339L234.302 0L176.968 47.0972V95.6108L142.223 60.8302L68.5389 68.862L61.296 142.708L95.6103 177.005H46.4336L0 234.769L47.097 292.103H95.6103L60.8299 326.866L68.8616 400.551L142.707 407.794L177.004 373.479V422.656L234.768 469.09L292.102 421.993V373.479L326.864 408.26L400.548 400.228L407.791 326.382L373.477 292.085H422.654L469.087 234.321L421.99 176.987L421.972 176.969Z"
              fill="white"
            />
          </svg>

          <div className="position-relative col-12 col-lg-6 my-24">
            <Form.Control
              placeholder="Hae ohjeista..."
              onKeyUp={onKeyUp}
              ref={searchInput}
            />
            <Button
              variant="link"
              className="pe-none position-absolute end-0 top-0"
              id="button-addon2"
              onClick={goToSearch}
            >
              <span className="bi bi-search"></span>
            </Button>
          </div>
        </div>

        {pageListPages && allPages ? (
          <Row xs={1} sm={2} md={3} className="g-24">
            {pageListPages.map((page, index) => {
              const subPages = allPages.filter(
                (f) => f.parentContentItemId == page.contentItemId,
              );

              return (
                <Col key={"p-" + page.contentItemId}>
                  <Card className="h-100">
                    <Card.Body>
                      <Card.Text as="div">
                        <h5 className="mb-24">
                          <Link
                            to={"https://www.lomarengas.fi" + page.path}
                            target="_blank"
                          >
                            {page.title}
                          </Link>
                        </h5>

                        {subPages.length > 0 && (
                          <ul className="list-unstyled d-grid gap-8 my-8">
                            {subPages.map((subPage, index) => {
                              return (
                                <li key={"sp-" + subPage.contentItemId}>
                                  <Link
                                    className=""
                                    to={
                                      "https://www.lomarengas.fi" + subPage.path
                                    }
                                    target="_blank"
                                  >
                                    {subPage.title}
                                  </Link>
                                </li>
                              );
                            })}
                          </ul>
                        )}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              );
            })}
          </Row>
        ) : (
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <Card.Text as="div" className="text-center">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Layout>
    </div>
  );
};

export default SupportPage;
